export default [
    {
        path: '/welfare',
        name: 'Welfare',
        component: () => import('../../views/Welfare.vue')
    },
    {
        path: '/welfare/:id',
        name: 'WelfareDetail',
        props: true,
        component: () => import('../../views/WelfareDetail.vue')
    }
]
